import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/lib/content";

const COMPANIES = [
  { name: "HAG Carpets", url: "https://www.hagcarpets.com" },
  { name: "Titas Footwear", url: "https://www.titasindia.com" },
  { name: "Youvora", url: "https://www.youvora.com" },
  { name: "Ag Perfume", url: "https://www.agperfume.com" },
  { name: "Nasir Biri", url: "https://www.nasirbiri.com" },
  { name: "Eskay Biri", url: "https://www.eskaybiri.com" },
  { name: "Arcadia", url: "https://myflexworx.com" },
];

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/divisions", label: "Divisions" },
  { to: "/journey", label: "Journey" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer className="ink-section" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src="/assets/skn-logo.webp"
            alt="SKN Group of Companies"
            className="h-12 w-auto brightness-0 invert opacity-90"
            data-testid="footer-logo"
          />
          <p className="mt-4 font-display italic text-lg text-[#B8997A]" data-testid="footer-tagline">
            Excellence that defines modern India
          </p>
          <p className="mt-5 text-sm leading-relaxed text-[#F7F5F0]/60 max-w-sm">
            A diversified Indian conglomerate founded in 1928 — carpets, footwear,
            fragrances, real estate and investments.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-[#B8997A] mb-6">Explore</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-nav-${n.label.toLowerCase()}`}
                  className="text-sm text-[#F7F5F0]/70 hover:text-[#B8997A] transition-colors duration-300"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-[#B8997A] mb-6">Companies</p>
          <ul className="space-y-3">
            {COMPANIES.map((c) => (
              <li key={c.name}>
                <a
                  href={c.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-company-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-[#F7F5F0]/70 hover:text-[#B8997A] transition-colors duration-300 inline-flex items-center gap-1"
                >
                  {c.name}
                  <ArrowUpRight size={12} strokeWidth={1.5} />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-[#B8997A] mb-6">Head Office</p>
          <address className="not-italic text-sm text-[#F7F5F0]/70 leading-relaxed space-y-3">
            <p data-testid="footer-address">{CONTACT.address}</p>
            <p>
              <a href={`tel:${CONTACT.phoneTel}`} className="hover:text-[#B8997A] transition-colors" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
            </p>
            <p>
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#B8997A] transition-colors" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </p>
          </address>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#F7F5F0]/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-[#F7F5F0]/40" data-testid="footer-copyright">
          © SKN Group. 2026. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <Link
            to="/login"
            data-testid="footer-employee-login"
            className="text-xs text-[#F7F5F0]/40 hover:text-[#B8997A] transition-colors"
          >
            Employee Login
          </Link>
          <p className="text-xs text-[#F7F5F0]/40 uppercase tracking-[0.25em]">
            Kolkata · Since 1928
          </p>
        </div>
      </div>
    </div>
  </footer>
);
